module.exports = __webpack_public_path__ + "assets/cuisine_type-ddd57c.svg";